module.exports = __webpack_public_path__ + "img/2566-08-03 18.11.10@2x.de44d038.png";